import script from "./SettingsTeamsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsTeamsSection.vue?vue&type=script&setup=true&lang=js"

import "./SettingsTeamsSection.vue?vue&type=style&index=0&id=5c13f56b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c13f56b"]])

export default __exports__